import { render } from "./MaintenanceView.vue?vue&type=template&id=5b7fde66&scoped=true"
import script from "./MaintenanceView.vue?vue&type=script&lang=js"
export * from "./MaintenanceView.vue?vue&type=script&lang=js"

import "./MaintenanceView.vue?vue&type=style&index=0&id=5b7fde66&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b7fde66"]])

export default __exports__